import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { HttpApiService } from '@recruitee/http';
import { AdminReportConfiguration } from '@recruitee/http/types';

@Injectable({ providedIn: 'root' })
export class ReportConfigurationHttpClient {
  constructor(protected httpApi: HttpApiService) {}

  public loadReportConfiguration(): Observable<AdminReportConfiguration> {
    return this.httpApi.get('/admin/report', null, null).pipe(map(data => data.adminReport));
  }

  public updateReportConfiguration(
    payload: Partial<AdminReportConfiguration>,
  ): Observable<AdminReportConfiguration> {
    return this.httpApi
      .patch('/admin/report', null, { adminReport: payload })
      .pipe(map(data => data.adminReport));
  }
}
